import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { getPublicIp } from 'src/utils/common';
import { ConsoleLogger } from 'src/utils/logger';

import Router from './Router';
import ChatNotificationListener from './components/ChatNotification/ChatNotificationListener';
import { isProduction, logArt } from './constants';
import { AuthProvider } from './stores/auth-context';

const logger = ConsoleLogger.getInstance();
getPublicIp().then((ip) => {
  logger.setPublicIp(ip);
});

const App: FC = () => {
  console.log(`%c\n${logArt}`, isProduction ? 'color:orange' : 'color:black');
  return (
    <BrowserRouter>
      <AuthProvider>
        <ChatNotificationListener />
        <Router />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
